import { FC } from 'react'
import {
  StyleCard,
  StyleLeftWrapper,
  StyleRightWrapper,
  StyleRowWrapper,
  StyleTag,
} from './style'
import Image from '@components/image'
import Row from '@components/row'
import Typography from '@components/typography'
import Svg from '@components/svg'
import Button from '@components/button'
interface InstituteDoctorCardProps {
  doctor: any
}
const InstituteDoctorCard: FC<InstituteDoctorCardProps> = ({ doctor }) => {
  return (
    <StyleCard>
      <StyleRowWrapper>
        <StyleLeftWrapper>
          <Image
            fallbackType="doctor"
            src={`${process.env.BUCKET_URL}/${doctor?.avatar}`}
          />
        </StyleLeftWrapper>
        <StyleRightWrapper>
          <Row justifyContent="space-between" alignItems="center">
            <Row alignItems="center" colGap={5}>
              <Typography content={doctor?.name} size={14} />
              {!!doctor.isApproved && (
                <Svg svg="verified" color={'secondary'} size={16} />
              )}
            </Row>
            <Row alignItems="center" colGap={5}>
              <Svg svg="star" color={'secondary'} size={16} />
              <Typography content={`4.5`} size={14} />
            </Row>
          </Row>
          <Row colGap={10}>
            <StyleTag>
              <Svg svg="plusHeart" />
              {doctor?.departments[0]?.name}
            </StyleTag>
            <StyleTag>
              <Svg svg="medal" />
              {doctor?.infos?.yos}
            </StyleTag>
            <StyleTag>{doctor?.infos?.qualification}</StyleTag>
          </Row>
          <Row justifyContent="flex-end" colGap={5} alignItems="center">
            <Svg svg="location" size={14} />
            <Typography
              content={doctor?.infos?.address}
              size={12}
              tc="text100"
            />
          </Row>
          <Row colGap={10}>
            <Button
              title="Edit"
              styleButton="width:100%;"
              styleButtonWrapper="width:49%;"
              outline
              data-cross-id={doctor?.id}
              data-cross-type={'Edit'}
            />
            <Button
              title="View Profile"
              styleButton="width:100%;"
              styleButtonWrapper="width:49%;"
              data-cross-id={doctor?.id}
              data-cross-type={'View'}
            />
          </Row>
        </StyleRightWrapper>
      </StyleRowWrapper>
    </StyleCard>
  )
}

export default InstituteDoctorCard
